import React, { useState, useRef } from 'react';
import { ArrowLeft, Eye, ArrowRight, Sparkles, Gift, Target } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const SwipeToReveal = ({ isDesktop = false }) => {
  const [swipeProgress, setSwipeProgress] = useState(0);
  const [isRevealed, setIsRevealed] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [prize, setPrize] = useState(null);
  const [showCelebration, setShowCelebration] = useState(false);
  const containerRef = useRef(null);

  const prizes = [
    {
      id: 1,
      title: " PIZZA Palace",
      subtitle: "50% OFF Today Only!",
       description: "Delicious wood-fired pizzas delivered hot to your door",
      cta: "ORDER NOW",
      bg: "/assets/hut.jpg", 
      image: "🍕",
      value: "50% OFF"
    },
    // {
    //   id: 2,
    //   title: "🎮 Gaming Store",
    //   subtitle: "$25 Gaming Credit",
    //   // description: "Level up your gaming experience with our exclusive credit",
    //   cta: "CLAIM NOW",
    //   bg: "from-purple-500 to-purple-600",
    //   image: "🎮",
    //   value: "$25"
    // },
    {
      id: 3,
      title: "Better Luck Next Time",
      subtitle: "Try again tomorrow for new prizes!",
      // description: "Don't give up! Amazing deals are waiting for you",
      cta: "TRY AGAIN",
      // bg: "from-slate-400 to-slate-500",
      bg: "/assets/hut.jpg", 
      image: "🎯",
      value: null
    }
  ];

  const generateRandomPrize = () => {
    const randomPrize = prizes[Math.floor(Math.random() * prizes.length)];
    setPrize(randomPrize);
    if (randomPrize.value) {
      setShowCelebration(true);
      setTimeout(() => setShowCelebration(false), 3000);
    }
  };

  const handleStart = (e) => {
    e.preventDefault();
    setIsDragging(true);
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    setStartX(clientX);
    if (!prize) generateRandomPrize();
  };

  const handleMove = (e) => {
    if (!isDragging) return;
    
    const container = containerRef.current;
    if (!container) return;
    
    const rect = container.getBoundingClientRect();
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const deltaX = clientX - startX;
    const progress = Math.max(0, Math.min(100, (deltaX / rect.width) * 100));
    
    setSwipeProgress(progress);
    
    if (progress > 70 && !isRevealed) {
      setIsRevealed(true);
    }
  };

  const handleEnd = () => {
    setIsDragging(false);
    
    if (swipeProgress < 70) {
      setSwipeProgress(0);
    } else {
      setSwipeProgress(100);
      setIsRevealed(true);
    }
  };

  const resetGame = () => {
    setSwipeProgress(0);
    setIsRevealed(false);
    setIsDragging(false);
    setPrize(null);
    setShowCelebration(false);
  };

  const completeReveal = () => {
    if (!prize) generateRandomPrize();
    setSwipeProgress(100);
    setIsRevealed(true);
  };

  return (
    <div className="w-full h-full bg-gradient-to-br from-slate-900 via-slate-900 to-slate-900 flex flex-col items-center justify-center overflow-hidden relative">
      {/* Background overlay */}
      <div 
  className="absolute inset-0 opacity-30"
  style={{
    backgroundImage: `url('/assets/hut.avif')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }}
></div>

      {/* Celebration confetti */}
      {/* {showCelebration && (
        <div className="absolute inset-0 pointer-events-none z-50">
          {[...Array(15)].map((_, i) => (
            <div
              key={i}
              className="absolute animate-bounce text-xl"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${2 + Math.random() * 2}s`
              }}
            >
              {['🎉', '🎊', '✨', '🌟'][Math.floor(Math.random() * 4)]}
            </div>
          ))}
        </div>
      )}
       */}
      <div className={`w-full ${isDesktop ? 'max-w-md' : 'max-w-xs'} text-center relative z-10 px-4`}>
        {/* Header */}
        <div className="mb-2 mt-2 animate-fadeIn">
          <h1 className="text-yellow-300 text-lg font-bold animate-pulse">
            Swipe to Reveal
          </h1>
          {/* <h2 className="text-yellow-300 text-md font-semibold ">
            Amazing Deals!
          </h2> */}
          {/* <p className="text-white/90 text-sm ">
            Swipe right to discover exclusive offers waiting for you! 
          </p> */}
        </div>

        {/* Swipe Card */}
        <div 
          ref={containerRef}
          className="relative mb-1 select-none"
        >
          {/* <div className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-2xl p-2 shadow-2xl relative overflow-hidden"> */}
          <div className="rounded-xl p-2 overflow-hidden relative 
      bg-gradient-to-br from-amber-700 via-yellow-600 to-yellow-500 
      border border-yellow-400/30 
      shadow-[0_4px_30px_rgba(251,191,36,0.4)] 
      backdrop-blur-xl">

            {/* Swipe Instruction */}
            <div className="text-center ">
              <h3 className="text-white text-md font-bold">
                Mystery Deal 
              </h3>
              <p className="text-white/90 text-sm mb-1">
                What amazing offer awaits you?
              </p>
            </div>

            {/* Swipe Area */}
            <div 
              className={`relative w-full ${isDesktop ? 'h-28' : 'h-28'} bg-gradient-to-r from-gray-200 to-gray-300 rounded-xl overflow-hidden cursor-grab select-none`}
              onMouseDown={handleStart}
              onMouseMove={handleMove}
              onMouseUp={handleEnd}
              onMouseLeave={handleEnd}
              onTouchStart={handleStart}
              onTouchMove={handleMove}
              onTouchEnd={handleEnd}
              style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
            >
              {/* Revealed Content (Behind) */}
              {prize && (
                // <div className={`absolute inset-0 bg-gradient-to-r ${prize.bg} flex flex-col items-center justify-center text-white p-2`}>
              //   <div
              //   className="absolute inset-0 bg-cover bg-center  text-white"
              //   style={{ backgroundImage: `url(${prize.bg})` }}
              // >
              //     <div className="absolute inset-0 bg-black/10 bg-opacity-20" />
              //     <div className="text-sm mb-1 text-white">
              //       {prize.image}
              //     </div>
              //     <h3 className="text-sm font-bold mb-1 text-center text-white" >
              //       {prize.title}
              //     </h3>
              //     <p className="text-sm font-bold mb-1 text-center text-white">
              //       {prize.subtitle}
              //     </p>
              //     <p className="text-xs text-center mb-1 opacity-90 text-white">
              //       {prize.description}
              //     </p>
              //     {/* {prize.value && (
              //       <div className="bg-white/20 backdrop-blur-sm rounded-full px-2 py-1 border border-white/30 ">
              //         <span className="font-bold text-sm">{prize.value}</span>
              //       </div>
              //     )} */}
              //     {/* <button className="bg-white text-gray-800 font-bold px-4 py-2 text-sm rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200">
              //       {prize.cta}
              //     </button> */}
              //   </div>

              <div
  className="absolute inset-0 bg-cover bg-center text-white flex flex-col items-center justify-center px-4 py-2"
  style={{ backgroundImage: `url(${prize.bg})` }}
>
  <div className="absolute inset-0 bg-black/60" />
  <div className="relative  text-sm mb-1 drop-shadow-md">{prize.image}</div>
  <h3 className="relative text-sm font-bold mb-1 text-center drop-shadow-lg">
    {prize.title}
  </h3>
  <p className="relative  text-sm font-bold mb-1 text-center drop-shadow">
    {prize.subtitle}
  </p>
  <p className="relative  text-xs text-center mb-1 opacity-90 drop-shadow">
    {prize.description}
  </p>
</div>

              )}

              {/* Overlay that slides away */}
              <div 
                className="absolute inset-0 bg-[#7b2b1a] flex flex-col items-center justify-center text-white transition-transform duration-300 ease-out"
                style={{ 
                  transform: `translateX(-${swipeProgress}%)`,
                  opacity: Math.max(0.1, 1 - swipeProgress / 100)
                }}
              >
                {/* <div className="text-lg mb-1 animate-pulse">
                  ❓
                </div> */}
                <h3 className="text-lg font-bold mb-1">
                  Mystery Deal❓
                </h3>
                <div className="flex items-center space-x-1 mb-1">
                  <div className="text-md">👉</div>
                  <p className="text-base font-semibold">
                    Swipe to Reveal
                  </p>
                </div>
                
                {/* Swipe Progress Indicator */}
                <div className="w-3/4 bg-white/30 rounded-full h-2 overflow-hidden">
                  <div 
                    className="bg-yellow-400 h-2 rounded-full transition-all duration-100"
                    style={{ width: `${swipeProgress}%` }}
                  />
                </div>
                <p className="text-xs mt-1 opacity-80">
                  {Math.round(swipeProgress)}% revealed
                </p>
              </div>

              {/* Swipe Handle */}
              {/* <div 
                className="absolute right-3 top-1/2 transform -translate-y-1/2 bg-white rounded-full w-10 h-10 shadow-lg flex items-center justify-center z-10 transition-all duration-300"
                style={{ 
                  transform: `translateY(-50%) translateX(${swipeProgress * 2}px)`,
                  opacity: swipeProgress > 90 ? 0 : 1
                }}
              >
                <div className="text-lg animate-pulse">
                  👉
                </div>
              </div> */}
            </div>

            {/* Progress Bar */}
            {swipeProgress > 0 && (
              <div className="mt-1">
                <div className="bg-gray-200 rounded-full h-2 overflow-hidden">
                  <div 
                    className="bg-gradient-to-r from-yellow-400 to-yellow-500 h-2 rounded-full transition-all duration-300"
                    style={{ width: `${swipeProgress}%` }}
                  />
                </div>
                <p className="text-center text-xs text-white/80 mt-1">
                  {swipeProgress >= 100 ? 'Revealed!' : `${Math.round(swipeProgress)}% swiped`}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-1 mb-4">
          {!isRevealed ? (
            <button 
              onClick={completeReveal}
              className="w-full bg-yellow-400 hover:bg-yellow-300 text-gray-800 font-bold py-1 px-1 text-base rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 animate-pulse flex items-center justify-center gap-2"
            >
              <Sparkles size={16} />
              <span>✨ Quick Reveal ✨</span>
            </button>
          ) : (
            <div className="space-y-1">
              {/* {prize?.value && (
                <button 
                  className="w-full bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white font-medium py-1 px-1 text-base rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-1"
                >
                  <Gift size={16} />
                  <span>Claim Reward</span>
                </button>
              )} */}
              <button 
                onClick={resetGame}
                className="w-full bg-green-500 hover:bg-green-400 text-white font-medium py-1 px-1 text-base rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-2"
              >
                <Target size={16} />
                <span>Discover More! 🔄</span>
              </button>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="text-center">
          <p className="text-white/80 text-xs mb-2">
            * Limited time offers. Swipe to unlock exclusive deals!
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.8s ease-out;
        }
      `}</style>
    </div>
  );
};

function App() {
  const [isMobile, setIsMobile] = useState(true);

  return (
    <>
     <Helmet>
       <title>
          BidBox AI – Your DSP Solution Partner for Targeted Advertising
          Campaigns
        </title>
        <meta
          name="description"
          content="Discover BidBox AI, a leading Demand-Side Platform (DSP) offering advanced solutions for targeted advertising campaigns. Optimize your ad spend and reach your audience effectively."
        />
        <meta
          name="keywords"
          content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
        />
         <link
          rel="canonical"
          href="https://bidbox.ai/swipe-to-reveal/pizza"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
    <div className="min-h-screen bg-gray-50 mt-10">
      <div className="container mx-auto px-8 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  Swipe for a Slice of Surprise
                  </h1>
                  <span className="bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Swipe to Reveal
                  </span>
                </div>
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                MAKE IT CRAVE-WORTHY
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                This interactive Swipe to Win Ad lets users swipe through options to reveal surprise deals like free sides or discounts.  designed to spark instant action and leave a lasting impression, boosting both conversions and brand recall. Just plug in your visuals and prize logic to launch.
                </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                  <span>Start with this Template</span>
                  <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                </button>
                </Link>
              </div>
            </div>
          </div>

          {/* Right column - Template Preview */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            {/* Preview toggle */}
            <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
                <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                  <div className="flex items-center space-x-4">
                    {/* <span className="text-sm text-gray-600 font-medium">Preview in:</span> */}
                    <div className="flex items-center space-x-3">
                      <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                      </button>
                      <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>
           
            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              
              {/* Mobile Mockup */}
              {isMobile && (
                <div className="mx-auto max-w-xs">
                  {/* iPhone mockup */}
                  <div className="relative bg-gray-200 rounded-[2.5rem] p-2 shadow-2xl">
                    {/* Status bar area */}
                    <div className="bg-white rounded-[2rem] overflow-hidden">
                      {/* Status bar */}
                      <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                        <span>9:41</span>
                        <div className="flex items-center space-x-1">
                          <div className="flex space-x-1">
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm relative">
                            <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                          </div>
                        </div>
                      </div>

                      {/* Browser bar */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                        <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                          swipe-to-win.com
                        </div>
                      </div>

                      {/* Content area */}
                      <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                        {/* Swipe Game - Full screen on mobile */}
                        <div className="space-y-3">
                    <div className="h-3 bg-gray-200 rounded w-full"></div>
                    <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                  </div>
                        <div className="mb-6">
                          <div className="relative group transform transition-all duration-300 rounded-lg overflow-hidden">
                            <SwipeToReveal isDesktop={false} />
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Desktop Mockup */}
              {!isMobile && (
                <div className="w-full max-w-4xl mx-auto hidden lg:block">
                  {/* Desktop Screen Frame */}
                  <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                    {/* Screen */}
                    <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                      {/* macOS-style window header */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center border-b border-gray-200">
                        <div className="flex space-x-2">
                          <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                        </div>
                        <div className="flex-1 mx-2">
                          <div className="bg-white rounded-md px-2 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                            🔒 swipe-to-win.com
                          </div>
                        </div>
                        <div className="flex space-x-2">
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                        </div>
                      </div>

                      {/* Browser content area */}
                      <div className="p-2 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                        {/* Swipe Game centered on desktop */}
                        <div className="mb-2">
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>

                          </div>
                        <div className="flex justify-center">
                          <div className="w-full max-w-md">
                            <SwipeToReveal isDesktop={true} />
                          </div>
                        </div>
                         {/* Additional content placeholders */}
                         <div className="grid grid-cols-2 gap-6 mb-6 mt-2">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3 mt-2">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Monitor stand */}
                  <div className="flex justify-center">
                    <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                  </div>
                  <div className="flex justify-center">
                    <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>

        <div className="max-w-7xl mx-auto px-4 py-10">
                    <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
              
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                      {/* Card 1 */}
                      <Link to="/3d-prism/prism" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/prism11.jpg"
                          alt="Card 1"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Prism</h2>
                        </div>
                      </Link>
              
                      {/* Card 2 */}
                      <Link to="/360rotate/carrotate" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/car121.webp"
                          alt="Card 2"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Car 360</h2>
                        </div>
                      </Link>
              
                      {/* Card 3 */}
                      <Link to="/hotspot/luxarycloset" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/luxary.webp"
                          alt="Card 3"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Luxary Closet</h2>
                        </div>
                      </Link>
              
                      {/* Card 4 */}
                      <Link to="/native-display/pepsi" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                        <img
                          src="/assets/pepsi.webp"
                          alt="Card 4"
                          className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                          <h2 className="text-lg font-semibold">Pepsi</h2>
                        </div>
                      </Link>
              
                     
                    </div>
                  </div>
    </>
  );
}

export default App;


// import React, { useState, useRef, useEffect } from 'react';
// import { ChevronLeft, ChevronRight, Copy, Play, Pause, Maximize2, Download, Share2, Eye, Settings, Monitor, Smartphone, Gift, Sparkles, Zap, Target, RotateCcw } from 'lucide-react';

// // Swipe to Reveal Component
// const SwipeToReveal = ({ isInPreview = false }) => {
//   const [swipeProgress, setSwipeProgress] = useState(0);
//   const [isRevealed, setIsRevealed] = useState(false);
//   const [isDragging, setIsDragging] = useState(false);
//   const [startX, setStartX] = useState(0);
//   const containerRef = useRef(null);

//   const ads = [
//     {
//       id: 1,
//       title: "🍕 PIZZA Palace",
//       subtitle: "50% OFF Today Only!",
//       description: "Delicious wood-fired pizzas delivered hot to your door",
//       cta: "ORDER NOW",
//       bg: "/assets/hut.avif", 
//       image: "🍕"
//     },
    
//   ];

//   const [currentAd, setCurrentAd] = useState(ads[0]);

//   const handleStart = (e) => {
//     setIsDragging(true);
//     const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
//     setStartX(clientX);
//   };

//   const handleMove = (e) => {
//     if (!isDragging) return;
    
//     const container = containerRef.current;
//     if (!container) return;
    
//     const rect = container.getBoundingClientRect();
//     const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
//     const deltaX = clientX - startX;
//     const progress = Math.max(0, Math.min(100, (deltaX / rect.width) * 100));
    
//     setSwipeProgress(progress);
    
//     if (progress > 70 && !isRevealed) {
//       setIsRevealed(true);
//     }
//   };

//   const handleEnd = () => {
//     setIsDragging(false);
    
//     if (swipeProgress < 70) {
//       setSwipeProgress(0);
//     } else {
//       setSwipeProgress(100);
//       setIsRevealed(true);
//     }
//   };

//   const resetAd = () => {
//     setSwipeProgress(0);
//     setIsRevealed(false);
//     setIsDragging(false);
//     const currentIndex = ads.findIndex(ad => ad.id === currentAd.id);
//     const nextIndex = (currentIndex + 1) % ads.length;
//     setCurrentAd(ads[nextIndex]);
//   };

//   const completeReveal = () => {
//     setSwipeProgress(100);
//     setIsRevealed(true);
//   };

//   return (
 
//     <div className="h-full w-full bg-gradient-to-br from-slate-900 via-slate-900 to-slate-900 flex flex-col items-center justify-center overflow-hidden relative">
//           <div 
//   className="absolute inset-0 opacity-30"
//   style={{
//     backgroundImage: `url('/assets/hut.avif')`,
//     backgroundSize: 'cover',
//     backgroundPosition: 'center'
//   }}
// ></div>
//       <div className="max-w-sm w-full text-center relative z-10 px-4">
//         {/* Header */}
//         <div className="mb-4 animate-fadeIn">
//           {/* <div className="text-3xl mb-2 animate-bounce">🎁</div> */}
//           <h1 className="text-white text-2xl font-bold mb-2 animate-pulse">
//             Swipe to Reveal
//           </h1>
//           <h2 className="text-yellow-300 text-lg font-semibold mb-2">
//             Amazing Deals!
//           </h2>
//           <p className="text-white/90 text-sm mb-2">
//             Swipe right to discover exclusive offers waiting for you! 
//           </p>
//         </div>

//         {/* Swipe Card */}
//         <div 
//           ref={containerRef}
//           className="relative mb-4 select-none"
//         >
//           <div className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-2xl p-4 shadow-2xl relative overflow-hidden">
//             {/* Swipe Instruction */}
//             <div className="text-center mb-3">
//               <h3 className="text-white text-lg font-bold mb-1">
//                 Mystery Deal 🎪
//               </h3>
//               <p className="text-white/90 text-sm mb-2">
//                 What amazing offer awaits you?
//               </p>
//             </div>

//             {/* Swipe Area */}
//             <div 
//               className="relative w-full h-48 bg-gradient-to-r from-gray-200 to-gray-300 rounded-xl overflow-hidden cursor-grab select-none"
//               onMouseDown={handleStart}
//               onMouseMove={handleMove}
//               onMouseUp={handleEnd}
//               onMouseLeave={handleEnd}
//               onTouchStart={handleStart}
//               onTouchMove={handleMove}
//               onTouchEnd={handleEnd}
//               style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
//             >
//               {/* Revealed Content (Behind) */}
//               {/* <div className={`absolute inset-0 bg-gradient-to-r ${currentAd.bgColor} flex flex-col items-center justify-center text-white p-4`}> */}
  //             <div
  //   className="absolute inset-0 bg-cover bg-center text-white"
  //   style={{ backgroundImage: `url(${currentAd.bg})` }}
  // >
//     {/* Dark overlay for better text visibility */}
//     <div className="absolute inset-0 bg-gray-700 bg-opacity-25"></div>
//                 <div className="text-3xl mb-1">
//                   {currentAd.image}
//                 </div>
//                 <h3 className="text-xl font-bold mb-2 text-center text-black">
//                   {currentAd.title}
//                 </h3>
//                 <p className="text-base font-semibold mb-2 text-center">
//                   {currentAd.subtitle}
//                 </p>
//                 <p className="text-xs text-center mb-2 opacity-90">
//                   {currentAd.description}
//                 </p>
//                 <button className="bg-white text-gray-800 font-bold px-4 py-2 text-sm rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200">
//                   {currentAd.cta}
//                 </button>
//               </div>

//               {/* Overlay that slides away */}
//               <div 
//                 className="absolute inset-0 bg-gradient-to-r from-gray-800 to-gray-600 flex flex-col items-center justify-center text-white transition-transform duration-300 ease-out"
//                 style={{ 
//                   transform: `translateX(-${swipeProgress}%)`,
//                   opacity: Math.max(0.1, 1 - swipeProgress / 100)
//                 }}
//               >
//                 <div className="text-4xl mb-3 animate-pulse">
//                   ❓
//                 </div>
//                 <h3 className="text-xl font-bold mb-2">
//                   Mystery Deal
//                 </h3>
//                 <div className="flex items-center space-x-2 mb-2">
//                   <div className="text-lg">👉</div>
//                   <p className="text-base font-semibold">
//                     Swipe to Reveal
//                   </p>
//                 </div>
                
//                 {/* Swipe Progress Indicator */}
//                 <div className="w-3/4 bg-white/30 rounded-full h-2 overflow-hidden">
//                   <div 
//                     className="bg-yellow-400 h-2 rounded-full transition-all duration-100"
//                     style={{ width: `${swipeProgress}%` }}
//                   />
//                 </div>
//                 <p className="text-xs mt-1 opacity-80">
//                   {Math.round(swipeProgress)}% revealed
//                 </p>
//               </div>

//               {/* Swipe Handle */}
//               <div 
//                 className="absolute right-3 top-1/2 transform -translate-y-1/2 bg-white rounded-full w-10 h-10 shadow-lg flex items-center justify-center z-10 transition-all duration-300"
//                 style={{ 
//                   transform: `translateY(-50%) translateX(${swipeProgress * 2}px)`,
//                   opacity: swipeProgress > 90 ? 0 : 1
//                 }}
//               >
//                 <div className="text-lg animate-pulse">
//                   👉
//                 </div>
//               </div>
//             </div>

//             {/* Progress Bar */}
//             {swipeProgress > 0 && (
//               <div className="mt-1">
//                 <div className="bg-gray-200 rounded-full h-2 overflow-hidden">
//                   <div 
//                     className={`bg-gradient-to-r ${currentAd.bgColor} h-2 rounded-full transition-all duration-300`}
//                     style={{ width: `${swipeProgress}%` }}
//                   />
//                 </div>
//                 <p className="text-center text-xs text-white/80 mt-1">
//                   {swipeProgress >= 100 ? 'Revealed!' : `${Math.round(swipeProgress)}% swiped`}
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Action Buttons */}
//         <div className="space-y-1 mb-1">
//           {!isRevealed ? (
//             <button 
//               onClick={completeReveal}
//               className="w-full bg-yellow-400 hover:bg-yellow-300 text-gray-800 font-bold py-1 px-2 text-base rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 animate-pulse"
//             >
//               ✨ Quick Reveal ✨
//             </button>
//           ) : (
//             <button 
//               onClick={resetAd}
//               className="w-full bg-green-500 hover:bg-green-400 text-white font-bold py-1 px-2 text-base rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200"
//             >
//               🔄 Discover More! 🔄
//             </button>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="text-center">
//           <p className="text-white/80 text-xs">
//             * Limited time offers. Swipe to unlock exclusive deals!
//           </p>
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.8s ease-out;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default function SwipeRevealMockup() {
//     const [selectedDevice, setSelectedDevice] = useState('Mobile');
//     const [isPlaying, setIsPlaying] = useState(false);

//     return (
//         <div className="mt-14 min-h-screen bg-gradient-to-br from-slate-50 via-purple-50 to-pink-50 p-6">
//             {/* Header */}
//             <div className="mb-8">
//                 <div className="flex items-center justify-between">
//                     <div>
//                         <h1 className="text-3xl font-bold text-gray-900 mb-2">Swipe-to-Reveal Campaign</h1>
//                         <p className="text-gray-600">Interactive mystery deal ad with swipe gesture</p>
//                     </div>
//                     <div className="flex items-center gap-3">
//                         <button className="px-4 py-2 bg-white rounded-lg shadow-sm border border-gray-200 hover:bg-gray-50 transition-colors flex items-center gap-2">
//                             <Settings className="h-4 w-4" />
//                             Settings
//                         </button>
//                         <button className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors flex items-center gap-2">
//                             <Share2 className="h-4 w-4" />
//                             Share
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
//                 {/* Left Sidebar - Project Info */}
//                 <div className="lg:col-span-1">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <div className="flex items-center gap-3 mb-4">
//                             <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl flex items-center justify-center">
//                                 <Gift className="h-6 w-6 text-white" />
//                             </div>
//                             <div>
//                                 <h2 className="text-lg font-semibold text-gray-900">Mystery Deals</h2>
//                                 <p className="text-sm text-gray-500">ID: 789123</p>
//                             </div>
//                         </div>
                        
//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Status</span>
//                                 <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">Active</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Campaign</span>
//                                 <span className="text-sm text-gray-900">Holiday 2024</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Updated</span>
//                                 <span className="text-sm text-gray-900">1 hour ago</span>
//                             </div>
//                         </div>

//                         <button className="w-full mt-4 text-purple-600 hover:text-purple-700 text-sm font-medium">
//                             View Campaign Analytics
//                         </button>
//                     </div>

//                     {/* Quick Actions */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
//                         <div className="space-y-3">
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-sm transition-colors flex items-center gap-2">
//                                 <Download className="h-4 w-4" />
//                                 Export Creative
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-sm transition-colors flex items-center gap-2">
//                                 <Copy className="h-4 w-4" />
//                                 Copy Ad Tag
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-sm transition-colors flex items-center gap-2">
//                                 <Maximize2 className="h-4 w-4" />
//                                 Fullscreen Test
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Center Content - Preview Area */}
//                 <div className="lg:col-span-2">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
//                         {/* Device Toggle */}
//                         <div className="flex items-center justify-between mb-6">
//                             <div className="flex items-center gap-2">
//                                 <h3 className="text-lg font-semibold text-gray-900">Interactive Preview</h3>
//                                 <Copy className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600 transition-colors" />
//                             </div>
//                             <div className="flex items-center bg-gray-100 rounded-lg p-1">
//                                 {[
//                                     { name: 'Mobile', icon: Smartphone },
//                                     { name: 'Desktop', icon: Monitor }
//                                 ].map(({ name, icon: Icon }) => (
//                                     <button
//                                         key={name}
//                                         className={`px-3 py-2 rounded-md text-sm font-medium transition-all flex items-center gap-2 ${
//                                             selectedDevice === name
//                                                 ? 'bg-white text-purple-600 shadow-sm'
//                                                 : 'text-gray-600 hover:text-gray-900'
//                                         }`}
//                                         onClick={() => setSelectedDevice(name)}
//                                     >
//                                         <Icon className="h-4 w-4" />
//                                         {name}
//                                     </button>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* Navigation */}
//                         <div className="flex items-center justify-between mb-6">
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors">
//                                 <ChevronLeft className="h-4 w-4" />
//                                 Previous Ad
//                             </button>
//                             <div className="flex items-center gap-2">
//                                 <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                             </div>
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors">
//                                 Next Ad
//                                 <ChevronRight className="h-4 w-4" />
//                             </button>
//                         </div>

//                         {/* Preview Container */}
//                         <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-8 min-h-[600px] flex items-center justify-center">
//                             {/* Device Frame */}
//                             <div className="relative">
//                                 {selectedDevice === 'Mobile' ? (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-3xl blur-xl"></div>
//                                         <div className="relative bg-gray-900 rounded-3xl p-2 shadow-2xl">
//                                             <div className="bg-black rounded-2xl overflow-hidden">
//                                                 <div className="w-[280px] h-[560px] relative">
//                                                     <SwipeToReveal isInPreview={true} />
//                                                 </div>
//                                             </div>
//                                             <div className="w-20 h-1 bg-gray-600 rounded-full mx-auto mt-2"></div>
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-xl blur-xl"></div>
//                                         <div className="relative bg-white rounded-xl shadow-2xl p-4">
//                                             <div className="bg-gray-100 rounded-lg p-2">
//                                                 <div className="w-[320px] h-[600px] bg-black rounded overflow-hidden relative">
//                                                     <SwipeToReveal isInPreview={true} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         {/* Interaction Guide */}
//                         <div className="mt-6 bg-purple-50 rounded-lg p-4">
//                             <div className="flex items-center gap-3">
//                                 <div className="w-8 h-8 bg-purple-600 text-white rounded-full flex items-center justify-center">
//                                     <Sparkles className="h-4 w-4" />
//                                 </div>
//                                 <div>
//                                     <h4 className="font-semibold text-purple-900">Interactive Elements</h4>
//                                     <p className="text-sm text-purple-700">Swipe right on the mystery card to reveal exclusive deals and offers</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Right Sidebar - Details */}
//                 <div className="lg:col-span-1">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Creative Details</h3>
                        
//                         <div className="space-y-4">
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">Dimensions</div>
//                                 <div className="text-lg font-semibold text-gray-900">320 × 600px</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">Format</div>
//                                 <div className="text-lg font-semibold text-gray-900">Interactive HTML5</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">Gesture</div>
//                                 <div className="text-lg font-semibold text-gray-900">Swipe Reveal</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-sm text-gray-600 mb-1">File Size</div>
//                                 <div className="text-lg font-semibold text-gray-900">1.8 MB</div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Performance Metrics */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Engagement Stats</h3>
//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Swipe Rate</span>
//                                 <span className="text-sm font-semibold text-green-600">8.3%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Reveal Rate</span>
//                                 <span className="text-sm font-semibold text-blue-600">6.2%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Click Through</span>
//                                 <span className="text-sm font-semibold text-purple-600">4.1%</span>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Interaction Flow */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Interaction Flow</h3>
//                         <div className="space-y-3">
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Mystery card display</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Swipe gesture detection</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Progressive reveal</span>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <div className="w-2 h-2 bg-green-500 rounded-full"></div>
//                                 <span className="text-sm text-gray-600">Deal completion</span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// import React, { useState, useRef, useEffect } from 'react';

// const SwipeToReveal = ({ isDesktop = false }) => {
//   const [swipeProgress, setSwipeProgress] = useState(0);
//   const [isRevealed, setIsRevealed] = useState(false);
//   const [isDragging, setIsDragging] = useState(false);
//   const [startX, setStartX] = useState(0);
//   const containerRef = useRef(null);

//   const ads = [
//     {
//       id: 1,
//       title: "🍕 PIZZA Hut",
//       subtitle: "50% OFF Today Only!",
//       description: "Delicious wood-fired pizzas delivered hot to your door",
//       cta: "ORDER NOW",
//       bg: "/assets/hut.avif", 
//       image: "🍕"
//     },
   
//   ];

//   const [currentAd, setCurrentAd] = useState(ads[0]);

//   const handleStart = (e) => {
//     setIsDragging(true);
//     const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
//     setStartX(clientX);
//   };

//   const handleMove = (e) => {
//     if (!isDragging) return;
    
//     const container = containerRef.current;
//     if (!container) return;
    
//     const rect = container.getBoundingClientRect();
//     const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
//     const deltaX = clientX - startX;
//     const progress = Math.max(0, Math.min(100, (deltaX / rect.width) * 100));
    
//     setSwipeProgress(progress);
    
//     if (progress > 70 && !isRevealed) {
//       setIsRevealed(true);
//     }
//   };

//   const handleEnd = () => {
//     setIsDragging(false);
    
//     if (swipeProgress < 70) {
//       // Snap back if not swiped enough
//       setSwipeProgress(0);
//     } else {
//       // Complete the reveal
//       setSwipeProgress(100);
//       setIsRevealed(true);
//     }
//   };

//   const resetAd = () => {
//     setSwipeProgress(0);
//     setIsRevealed(false);
//     setIsDragging(false);
//     // Show next ad
//     const currentIndex = ads.findIndex(ad => ad.id === currentAd.id);
//     const nextIndex = (currentIndex + 1) % ads.length;
//     setCurrentAd(ads[nextIndex]);
//   };

//   const completeReveal = () => {
//     setSwipeProgress(100);
//     setIsRevealed(true);
//   };

//   return (
//     <div className="h-full w-full bg-gradient-to-br from-slate-900 via-slate-900 to-slate-900 flex flex-col items-center justify-center overflow-hidden relative">
//           <div 
//   className="absolute inset-0 opacity-30"
//   style={{
//     backgroundImage: `url('/assets/hut.avif')`,
//     backgroundSize: 'cover',
//     backgroundPosition: 'center'
//   }}
// ></div>
      
//       {/* Animated Background Elements */}
//       <div className="absolute inset-0 overflow-hidden pointer-events-none">
//         <div className={`absolute ${isDesktop ? 'top-12 left-12 text-4xl' : 'top-8 left-8 text-3xl'} animate-bounce opacity-20`}>✨</div>
//         <div className={`absolute ${isDesktop ? 'top-20 right-16 text-5xl' : 'top-16 right-12 text-4xl'} animate-pulse opacity-20`}>🎯</div>
//         <div className={`absolute ${isDesktop ? 'bottom-20 left-20 text-4xl' : 'bottom-24 left-16 text-3xl'} animate-bounce delay-500 opacity-20`}>🔥</div>
//         <div className={`absolute ${isDesktop ? 'bottom-12 right-12 text-4xl' : 'bottom-8 right-8 text-3xl'} animate-pulse delay-300 opacity-20`}>⚡</div>
//       </div>

//       <div className={`${isDesktop ? 'max-w-4xl px-12' : 'max-w-sm px-4'} w-full text-center relative z-10`}>
//         {/* Header */}
//         <div className={`${isDesktop ? 'mb-2' : 'mb-2'} animate-fadeIn`}>
//           {/* <div className={`${isDesktop ? 'text-4xl mb-2' : 'text-4xl mb-3'} animate-bounce`}>🎁</div> */}
//           <h1 className={`text-white ${isDesktop ? 'text-4xl' : 'text-3xl mt-6'} font-bold mb-2 animate-pulse`}>
//             Swipe to Reveal
//           </h1>
//           <h2 className={`text-yellow-300 ${isDesktop ? 'text-2xl' : 'text-xl'} font-semibold mb-2`}>
//             Amazing Deals!
//           </h2>
//           <p className={`text-white/90 ${isDesktop ? 'text-base' : 'text-sm'} mb-1`}>
//             Swipe right to discover exclusive offers waiting for you! 
//           </p>
//         </div>

//         {/* Swipe Card */}
//         <div 
//           ref={containerRef}
//           className={`relative ${isDesktop ? 'mb-3' : 'mb-3'} select-none`}
//         >
//           <div className={`bg-white rounded-3xl bg-opacity-20 backdrop-blur-lg border border-white border-opacity-30 ${isDesktop ? 'p-6' : 'p-6'} shadow-2xl relative overflow-hidden`}>
//             {/* Swipe Instruction */}
//             <div className={`text-center ${isDesktop ? 'mb-2' : 'mb-2'}`}>
//               <h3 className={`text-gray-900 ${isDesktop ? 'text-2xl' : 'text-2xl'} font-bold mb-2`}>
//                 Mystery Deal 🎪
//               </h3>
//               <p className={`text-gray-900 ${isDesktop ? 'text-base' : 'text-base'} mb-2`}>
//                 What amazing offer awaits you?
//               </p>
//             </div>

//             {/* Swipe Area */}
//             <div 
//               className={`relative w-full ${isDesktop ? 'h-60' : 'h-60'} bg-gradient-to-r from-gray-200 to-gray-300 rounded-2xl overflow-hidden cursor-grab select-none`}
//               onMouseDown={handleStart}
//               onMouseMove={handleMove}
//               onMouseUp={handleEnd}
//               onMouseLeave={handleEnd}
//               onTouchStart={handleStart}
//               onTouchMove={handleMove}
//               onTouchEnd={handleEnd}
//               style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
//             >
//               {/* Revealed Content (Behind) */}
//               {/* <div className={`absolute inset-0 bg-gradient-to-r ${currentAd.bgColor} flex flex-col items-center justify-center text-white p-4`}>
                
        
// <div className={`${isDesktop ? 'text-5xl mb-3' : 'text-4xl mb-2'}`}>
//                   {currentAd.image}
//                 </div>
//                 <h3 className={`${isDesktop ? 'text-2xl' : 'text-2xl'} font-bold mb-2 text-center`}>
//                   {currentAd.title}
//                 </h3>
//                 <p className={`${isDesktop ? 'text-lg' : 'text-lg'} font-semibold mb-2 text-center`}>
//                   {currentAd.subtitle}
//                 </p>
//                 <p className={`${isDesktop ? 'text-sm' : 'text-sm'} text-center mb-2 opacity-90`}>
//                   {currentAd.description}
//                 </p>
//                 <button className={`bg-white text-gray-800 font-bold ${isDesktop ? 'px-6 py-3 text-base' : 'px-6 py-2 text-lg'} rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200`}>
//                   {currentAd.cta}
//                 </button>
//               </div> */}

//    {/* <div className={`absolute inset-0 bg-gradient-to-r ${currentAd.bgColor} flex flex-col items-center justify-center text-white p-4`}> */}
  //  <div
  //   className="absolute inset-0 bg-cover bg-center text-white"
  //   style={{ backgroundImage: `url(${currentAd.bg})` }}
  // >
  //   {/* Dark overlay for better text visibility */}
  //   <div className="absolute inset-0 bg-gray-700 bg-opacity-25"></div>
 
        
// <div className={`${isDesktop ? 'text-5xl mb-3' : 'text-4xl mb-2'}`}>
//                   {currentAd.image}
//                 </div>
//                 <h3 className={`${isDesktop ? 'text-2xl' : 'text-2xl'} font-bold mb-2 text-center`}>
//                   {currentAd.title}
//                 </h3>
//                 <p className={`${isDesktop ? 'text-lg' : 'text-lg'} font-semibold mb-2 text-center`}>
//                   {currentAd.subtitle}
//                 </p>
//                 <p className={`${isDesktop ? 'text-sm' : 'text-sm'} text-center mb-2 opacity-90`}>
//                   {currentAd.description}
//                 </p>
//                 <button className={`bg-white text-gray-800 font-bold ${isDesktop ? 'px-6 py-3 text-base' : 'px-6 py-2 text-lg'} rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200`}>
//                   {currentAd.cta}
//                 </button>
//               </div>
//               {/* Overlay that slides away */}
//               <div 
//                 className={`absolute inset-0 bg-gradient-to-r from-gray-800 to-gray-600 flex flex-col items-center justify-center text-white transition-transform duration-300 ease-out`}
//                 style={{ 
//                   transform: `translateX(-${swipeProgress}%)`,
//                   opacity: Math.max(0.1, 1 - swipeProgress / 100)
//                 }}
//               >
//                 <div className={`${isDesktop ? 'text-5xl mb-4' : 'text-6xl mb-4'} animate-pulse`}>
//                   ❓
//                 </div>
//                 <h3 className={`${isDesktop ? 'text-2xl' : 'text-2xl'} font-bold mb-3`}>
//                   Mystery Deal
//                 </h3>
//                 <div className="flex items-center space-x-2 mb-3">
//                   <div className={`${isDesktop ? 'text-xl' : 'text-xl'}`}>👉</div>
//                   <p className={`${isDesktop ? 'text-lg' : 'text-lg'} font-semibold`}>
//                     Swipe to Reveal
//                   </p>
//                 </div>
                
//                 {/* Swipe Progress Indicator */}
//                 <div className={`w-3/4 bg-white/30 rounded-full ${isDesktop ? 'h-3' : 'h-3'} overflow-hidden`}>
//                   <div 
//                     className={`bg-yellow-400 ${isDesktop ? 'h-3' : 'h-3'} rounded-full transition-all duration-100`}
//                     style={{ width: `${swipeProgress}%` }}
//                   />
//                 </div>
//                 <p className={`${isDesktop ? 'text-sm' : 'text-sm'} mt-2 opacity-80`}>
//                   {Math.round(swipeProgress)}% revealed
//                 </p>
//               </div>

//               {/* Swipe Handle */}
//               <div 
//                 className={`absolute ${isDesktop ? 'right-4 top-1/2' : 'right-4 top-1/2'} transform -translate-y-1/2 bg-white rounded-full ${isDesktop ? 'w-12 h-12' : 'w-12 h-12'} shadow-lg flex items-center justify-center z-10 transition-all duration-300`}
//                 style={{ 
//                   transform: `translateY(-50%) translateX(${swipeProgress * 3}px)`,
//                   opacity: swipeProgress > 90 ? 0 : 1
//                 }}
//               >
//                 <div className={`${isDesktop ? 'text-xl' : 'text-xl'} animate-pulse`}>
//                   👉
//                 </div>
//               </div>
//             </div>

//             {/* Progress Bar */}
//             {swipeProgress > 0 && (
//               <div className={`${isDesktop ? 'mt-4' : 'mt-4'}`}>
//                 <div className={`bg-gray-200 rounded-full ${isDesktop ? 'h-2' : 'h-2'} overflow-hidden`}>
//                   <div 
//                     className={`bg-gradient-to-r ${currentAd.bgColor} ${isDesktop ? 'h-2' : 'h-2'} rounded-full transition-all duration-300`}
//                     style={{ width: `${swipeProgress}%` }}
//                   />
//                 </div>
//                 <p className={`text-center ${isDesktop ? 'text-xs' : 'text-xs'} text-gray-500 mt-1`}>
//                   {swipeProgress >= 100 ? 'Revealed!' : `${Math.round(swipeProgress)}% swiped`}
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Action Buttons */}
//         <div className={`space-y-3 ${isDesktop ? 'mb-4' : 'mb-4'}`}>
//           {!isRevealed ? (
//             <button 
//               onClick={completeReveal}
//               className={`w-full bg-yellow-400 hover:bg-yellow-300 text-gray-800 font-bold ${isDesktop ? 'py-4 px-6 text-lg' : 'py-2 px-4 text-lg'} rounded-2xl shadow-lg transform hover:scale-105 transition-all duration-200 animate-pulse`}
//             >
//               ✨ Quick Reveal ✨
//             </button>
//           ) : (
//             <button 
//               onClick={resetAd}
//               className={`w-full bg-green-500 hover:bg-green-400 text-white font-bold ${isDesktop ? 'py-4 px-6 text-lg' : 'py-2 px-4 text-lg'} rounded-2xl shadow-lg transform hover:scale-105 transition-all duration-200`}
//             >
//               🔄 Discover More! 🔄
//             </button>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="text-center">
//           <p className={`text-white/80 ${isDesktop ? 'text-sm' : 'text-sm'}`}>
//             * Limited time offers. Swipe to unlock exclusive deals!
//           </p>
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.8s ease-out;
//         }
//       `}</style>
//     </div>
//   );
// };

// const PhoneMockup = () => {
//   return (
//     <div className="relative">
//       <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-[2.5rem] p-2 shadow-2xl border-4 border-slate-700">
//         <div className="bg-black rounded-[2rem] p-1">
//           <div className="w-[320px] h-[640px] bg-white rounded-[1.5rem] overflow-hidden relative shadow-inner">
//             {/* Phone Status Bar */}
//             <div className="absolute top-2 left-4 right-4 flex justify-between items-center z-50 text-white text-xs font-medium">
//               <span>9:41</span>
//               <div className="flex items-center space-x-1">
//                 <div className="flex space-x-1">
//                   <div className="w-1 h-1 bg-white rounded-full"></div>
//                   <div className="w-1 h-1 bg-white rounded-full"></div>
//                   <div className="w-1 h-1 bg-white rounded-full opacity-50"></div>
//                 </div>
//                 <div className="w-6 h-3 border border-white rounded-sm ml-2">
//                   <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="w-full h-full">
//               <SwipeToReveal isDesktop={false} />
//             </div>
//           </div>
//         </div>
//         {/* Home Indicator */}
//         <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-slate-600 rounded-full"></div>
//       </div>
//       {/* Reflection Effect */}
//       <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white to-transparent opacity-10 rounded-[2.5rem] pointer-events-none"></div>
//     </div>
//   );
// };

// const DesktopMockup = () => {
//   return (
//     <div className="relative">
//       <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-4 shadow-2xl border-4 border-slate-700">
//         <div className="bg-black rounded-xl p-2">
//           <div className="w-[800px] h-[700px] bg-white rounded-lg overflow-hidden relative shadow-inner">
//             {/* Browser Header */}
//             <div className="absolute top-0 left-0 right-0 h-10 bg-gray-100 border-b border-gray-300 flex items-center px-4 z-40">
//               <div className="flex space-x-2">
//                 <div className="w-3 h-3 bg-red-500 rounded-full"></div>
//                 <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
//                 <div className="w-3 h-3 bg-green-500 rounded-full"></div>
//               </div>
//               <div className="flex-1 mx-6">
//                 <div className="bg-white rounded-lg px-3 py-1 text-xs text-gray-600 border shadow-inner">
//                   🔒 https://mystore.com/swipe-deals
//                 </div>
//               </div>
//               <div className="flex space-x-2">
//                 <div className="w-6 h-6 bg-gray-300 rounded hover:bg-gray-400 transition-colors"></div>
//                 <div className="w-6 h-6 bg-gray-300 rounded hover:bg-gray-400 transition-colors"></div>
//               </div>
//             </div>
//             <div className="w-full h-full pt-10 overflow-hidden">
//               <SwipeToReveal isDesktop={true} />
//             </div>
//           </div>
//         </div>
//         {/* Desktop Stand */}
//         <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-6">
//           <div className="w-32 h-6 bg-gradient-to-b from-slate-600 to-slate-800 rounded-b-xl shadow-lg"></div>
//           <div className="w-48 h-3 bg-gradient-to-b from-slate-700 to-slate-900 rounded-full mx-auto shadow-lg"></div>
//         </div>
//       </div>
//       {/* Reflection Effect */}
//       <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white to-transparent opacity-10 rounded-2xl pointer-events-none"></div>
//     </div>
//   );
// };

// const ResponsiveSwipeReveal = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 overflow-hidden">
//       {/* Mobile View */}
//       <div className="lg:hidden flex items-center justify-center min-h-screen px-4 mt-16">
//         <PhoneMockup />
//       </div>
      
//       {/* Both Views for Comparison (visible on xl screens) */}
//       <div className="hidden xl:flex xl:flex-row xl:space-x-12 xl:items-center xl:justify-center xl:min-h-screen xl:py-8 xl:px-8">
//         <div className="flex flex-col items-center mt-14">
//           <h3 className="text-white text-xl font-bold mb-4 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-xl border border-white/20">
//             🖥️ Desktop Experience
//           </h3>
//           <DesktopMockup />
//         </div>
//         <div className="flex flex-col items-center">
//           <h3 className="text-white text-xl font-bold mb-4 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-xl border border-white/20">
//             📱 Mobile Experience
//           </h3>
//           <PhoneMockup />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ResponsiveSwipeReveal;


// import React, { useState, useRef, useEffect } from 'react';

// const SwipeToReveal = ({ isDesktop = false }) => {
//   const [swipeProgress, setSwipeProgress] = useState(0);
//   const [isRevealed, setIsRevealed] = useState(false);
//   const [isDragging, setIsDragging] = useState(false);
//   const [startX, setStartX] = useState(0);
//   const containerRef = useRef(null);

//   const ads = [
//     {
//       id: 1,
//       title: "🍕 PIZZA PARADISE",
//       subtitle: "50% OFF Today Only!",
//       description: "Delicious wood-fired pizzas delivered hot to your door",
//       cta: "ORDER NOW",
//       bgColor: "from-red-500 to-orange-500",
//       image: "🍕"
//     },
//     {
//       id: 2,
//       title: "☕ BREW MASTERS",
//       subtitle: "Buy 2 Get 1 FREE",
//       description: "Premium coffee beans roasted to perfection",
//       cta: "SHOP COFFEE",
//       bgColor: "from-amber-800 to-yellow-600",
//       image: "☕"
//     },
//     {
//       id: 3,
//       title: "🍔 BURGER BLISS",
//       subtitle: "Free Delivery!",
//       description: "Gourmet burgers made with fresh, local ingredients",
//       cta: "GET YOURS",
//       bgColor: "from-green-600 to-lime-500",
//       image: "🍔"
//     },
//     {
//       id: 4,
//       title: "🍰 SWEET TREATS",
//       subtitle: "30% OFF Desserts",
//       description: "Handcrafted cakes and pastries for every occasion",
//       cta: "TASTE NOW",
//       bgColor: "from-pink-500 to-purple-500",
//       image: "🍰"
//     }
//   ];

//   const [currentAd, setCurrentAd] = useState(ads[0]);

//   const handleStart = (e) => {
//     setIsDragging(true);
//     const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
//     setStartX(clientX);
//   };

//   const handleMove = (e) => {
//     if (!isDragging) return;
    
//     const container = containerRef.current;
//     if (!container) return;
    
//     const rect = container.getBoundingClientRect();
//     const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
//     const deltaX = clientX - startX;
//     const progress = Math.max(0, Math.min(100, (deltaX / rect.width) * 100));
    
//     setSwipeProgress(progress);
    
//     if (progress > 70 && !isRevealed) {
//       setIsRevealed(true);
//     }
//   };

//   const handleEnd = () => {
//     setIsDragging(false);
    
//     if (swipeProgress < 70) {
//       // Snap back if not swiped enough
//       setSwipeProgress(0);
//     } else {
//       // Complete the reveal
//       setSwipeProgress(100);
//       setIsRevealed(true);
//     }
//   };

//   const resetAd = () => {
//     setSwipeProgress(0);
//     setIsRevealed(false);
//     setIsDragging(false);
//     // Show next ad
//     const currentIndex = ads.findIndex(ad => ad.id === currentAd.id);
//     const nextIndex = (currentIndex + 1) % ads.length;
//     setCurrentAd(ads[nextIndex]);
//   };

//   const completeReveal = () => {
//     setSwipeProgress(100);
//     setIsRevealed(true);
//   };

//   return (
//     <div className="h-full bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600 flex flex-col items-center justify-center p-4 overflow-hidden relative">
//       {/* Animated Background Elements */}
//       <div className="absolute inset-0 overflow-hidden pointer-events-none">
//         <div className={`absolute ${isDesktop ? 'top-16 left-16 text-6xl' : 'top-8 left-8 text-4xl'} animate-bounce opacity-20`}>✨</div>
//         <div className={`absolute ${isDesktop ? 'top-32 right-20 text-8xl' : 'top-16 right-12 text-6xl'} animate-pulse opacity-20`}>🎯</div>
//         <div className={`absolute ${isDesktop ? 'bottom-32 left-24 text-7xl' : 'bottom-24 left-16 text-5xl'} animate-bounce delay-500 opacity-20`}>🔥</div>
//         <div className={`absolute ${isDesktop ? 'bottom-16 right-16 text-6xl' : 'bottom-8 right-8 text-4xl'} animate-pulse delay-300 opacity-20`}>⚡</div>
//       </div>

//       <div className={`${isDesktop ? 'max-w-2xl' : 'max-w-sm'} w-full text-center relative z-10`}>
//         {/* Header */}
//         <div className={`${isDesktop ? 'mb-8' : 'mb-6'} animate-fadeIn`}>
//           <div className={`${isDesktop ? 'text-6xl mb-4' : 'text-4xl mb-3'} animate-bounce`}>🎁</div>
//           <h1 className={`text-white ${isDesktop ? 'text-5xl' : 'text-3xl'} font-bold mb-2 animate-pulse`}>
//             Swipe to Reveal
//           </h1>
//           <h2 className={`text-yellow-300 ${isDesktop ? 'text-3xl' : 'text-xl'} font-semibold mb-3`}>
//             Amazing Deals!
//           </h2>
//           <p className={`text-white/90 ${isDesktop ? 'text-lg' : 'text-sm'} mb-2`}>
//             Swipe right to discover exclusive offers waiting for you! 
//           </p>
//         </div>

//         {/* Swipe Card */}
//         <div 
//           ref={containerRef}
//           className={`relative ${isDesktop ? 'mb-8' : 'mb-6'} select-none`}
//         >
//           <div className={`bg-white rounded-3xl ${isDesktop ? 'p-8' : 'p-6'} shadow-2xl relative overflow-hidden`}>
//             {/* Swipe Instruction */}
//             <div className={`text-center ${isDesktop ? 'mb-6' : 'mb-4'}`}>
//               <h3 className={`text-gray-800 ${isDesktop ? 'text-3xl' : 'text-2xl'} font-bold mb-2`}>
//                 Mystery Deal 🎪
//               </h3>
//               <p className={`text-gray-600 ${isDesktop ? 'text-lg' : 'text-base'} mb-2`}>
//                 What amazing offer awaits you?
//               </p>
//             </div>

//             {/* Swipe Area */}
//             <div 
//               className={`relative w-full ${isDesktop ? 'h-80' : 'h-64'} bg-gradient-to-r from-gray-200 to-gray-300 rounded-2xl overflow-hidden cursor-grab select-none`}
//               onMouseDown={handleStart}
//               onMouseMove={handleMove}
//               onMouseUp={handleEnd}
//               onMouseLeave={handleEnd}
//               onTouchStart={handleStart}
//               onTouchMove={handleMove}
//               onTouchEnd={handleEnd}
//               style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
//             >
//               {/* Revealed Content (Behind) */}
//               <div className={`absolute inset-0 bg-gradient-to-r ${currentAd.bgColor} flex flex-col items-center justify-center text-white p-6`}>
//                 <div className={`${isDesktop ? 'text-8xl mb-6' : 'text-6xl mb-4'}`}>
//                   {currentAd.image}
//                 </div>
//                 <h3 className={`${isDesktop ? 'text-4xl' : 'text-2xl'} font-bold mb-2 text-center`}>
//                   {currentAd.title}
//                 </h3>
//                 <p className={`${isDesktop ? 'text-2xl' : 'text-lg'} font-semibold mb-3 text-center`}>
//                   {currentAd.subtitle}
//                 </p>
//                 <p className={`${isDesktop ? 'text-lg' : 'text-sm'} text-center mb-6 opacity-90`}>
//                   {currentAd.description}
//                 </p>
//                 <button className={`bg-white text-gray-800 font-bold ${isDesktop ? 'px-8 py-4 text-xl' : 'px-6 py-3 text-lg'} rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200`}>
//                   {currentAd.cta}
//                 </button>
//               </div>

//               {/* Overlay that slides away */}
//               <div 
//                 className={`absolute inset-0 bg-gradient-to-r from-gray-800 to-gray-600 flex flex-col items-center justify-center text-white transition-transform duration-300 ease-out`}
//                 style={{ 
//                   transform: `translateX(-${swipeProgress}%)`,
//                   opacity: Math.max(0.1, 1 - swipeProgress / 100)
//                 }}
//               >
//                 <div className={`${isDesktop ? 'text-8xl mb-8' : 'text-6xl mb-6'} animate-pulse`}>
//                   ❓
//                 </div>
//                 <h3 className={`${isDesktop ? 'text-3xl' : 'text-2xl'} font-bold mb-4`}>
//                   Mystery Deal
//                 </h3>
//                 <div className="flex items-center space-x-2 mb-4">
//                   <div className={`${isDesktop ? 'text-2xl' : 'text-xl'}`}>👉</div>
//                   <p className={`${isDesktop ? 'text-xl' : 'text-lg'} font-semibold`}>
//                     Swipe to Reveal
//                   </p>
//                 </div>
                
//                 {/* Swipe Progress Indicator */}
//                 <div className={`w-3/4 bg-white/30 rounded-full ${isDesktop ? 'h-4' : 'h-3'} overflow-hidden`}>
//                   <div 
//                     className={`bg-yellow-400 ${isDesktop ? 'h-4' : 'h-3'} rounded-full transition-all duration-100`}
//                     style={{ width: `${swipeProgress}%` }}
//                   />
//                 </div>
//                 <p className={`${isDesktop ? 'text-base' : 'text-sm'} mt-2 opacity-80`}>
//                   {Math.round(swipeProgress)}% revealed
//                 </p>
//               </div>

//               {/* Swipe Handle */}
//               <div 
//                 className={`absolute ${isDesktop ? 'right-6 top-1/2' : 'right-4 top-1/2'} transform -translate-y-1/2 bg-white rounded-full ${isDesktop ? 'w-16 h-16' : 'w-12 h-12'} shadow-lg flex items-center justify-center z-10 transition-all duration-300`}
//                 style={{ 
//                   transform: `translateY(-50%) translateX(${swipeProgress * 3}px)`,
//                   opacity: swipeProgress > 90 ? 0 : 1
//                 }}
//               >
//                 <div className={`${isDesktop ? 'text-2xl' : 'text-xl'} animate-pulse`}>
//                   👉
//                 </div>
//               </div>
//             </div>

//             {/* Progress Bar */}
//             {swipeProgress > 0 && (
//               <div className={`${isDesktop ? 'mt-6' : 'mt-4'}`}>
//                 <div className={`bg-gray-200 rounded-full ${isDesktop ? 'h-3' : 'h-2'} overflow-hidden`}>
//                   <div 
//                     className={`bg-gradient-to-r ${currentAd.bgColor} ${isDesktop ? 'h-3' : 'h-2'} rounded-full transition-all duration-300`}
//                     style={{ width: `${swipeProgress}%` }}
//                   />
//                 </div>
//                 <p className={`text-center ${isDesktop ? 'text-sm' : 'text-xs'} text-gray-500 mt-1`}>
//                   {swipeProgress >= 100 ? 'Revealed!' : `${Math.round(swipeProgress)}% swiped`}
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Action Buttons */}
//         <div className={`space-y-4 ${isDesktop ? 'mb-6' : 'mb-4'}`}>
//           {!isRevealed ? (
//             <button 
//               onClick={completeReveal}
//               className={`w-full bg-yellow-400 hover:bg-yellow-300 text-gray-800 font-bold ${isDesktop ? 'py-6 px-8 text-2xl' : 'py-4 px-6 text-lg'} rounded-2xl shadow-lg transform hover:scale-105 transition-all duration-200 animate-pulse`}
//             >
//               ✨ Quick Reveal ✨
//             </button>
//           ) : (
//             <button 
//               onClick={resetAd}
//               className={`w-full bg-green-500 hover:bg-green-400 text-white font-bold ${isDesktop ? 'py-6 px-8 text-2xl' : 'py-4 px-6 text-lg'} rounded-2xl shadow-lg transform hover:scale-105 transition-all duration-200`}
//             >
//               🔄 Discover More! 🔄
//             </button>
//           )}
//         </div>

//         {/* Footer */}
//         <div className="text-center">
//           <p className={`text-white/80 ${isDesktop ? 'text-base' : 'text-sm'}`}>
//             * Limited time offers. Swipe to unlock exclusive deals!
//           </p>
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.8s ease-out;
//         }
//       `}</style>
//     </div>
//   );
// };

// const PhoneMockup = () => {
//   return (
//     <div className="relative">
//       <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-[2.5rem] p-2 shadow-2xl border-4 border-slate-700">
//         <div className="bg-black rounded-[2rem] p-1">
//           <div className="w-[320px] h-[640px] bg-white rounded-[1.5rem] overflow-hidden relative shadow-inner">
//             {/* Phone Status Bar */}
//             <div className="absolute top-2 left-4 right-4 flex justify-between items-center z-50 text-white text-xs font-medium">
//               <span>9:41</span>
//               <div className="flex items-center space-x-1">
//                 <div className="flex space-x-1">
//                   <div className="w-1 h-1 bg-white rounded-full"></div>
//                   <div className="w-1 h-1 bg-white rounded-full"></div>
//                   <div className="w-1 h-1 bg-white rounded-full opacity-50"></div>
//                 </div>
//                 <div className="w-6 h-3 border border-white rounded-sm ml-2">
//                   <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
//                 </div>
//               </div>
//             </div>
//             <div className="w-full h-full">
//               <SwipeToReveal isDesktop={false} />
//             </div>
//           </div>
//         </div>
//         {/* Home Indicator */}
//         <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-slate-600 rounded-full"></div>
//       </div>
//       {/* Reflection Effect */}
//       <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white to-transparent opacity-10 rounded-[2.5rem] pointer-events-none"></div>
//     </div>
//   );
// };

// const DesktopMockup = () => {
//   return (
//     <div className="relative">
//       <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-4 shadow-2xl border-4 border-slate-700">
//         <div className="bg-black rounded-xl p-2">
//           <div className="w-[900px] h-[700px] bg-white rounded-lg overflow-hidden relative shadow-inner">
//             {/* Browser Header */}
//             <div className="absolute top-0 left-0 right-0 h-12 bg-gray-100 border-b border-gray-300 flex items-center px-4 z-50">
//               <div className="flex space-x-2">
//                 <div className="w-3 h-3 bg-red-500 rounded-full"></div>
//                 <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
//                 <div className="w-3 h-3 bg-green-500 rounded-full"></div>
//               </div>
//               <div className="flex-1 mx-6">
//                 <div className="bg-white rounded-lg px-4 py-2 text-sm text-gray-600 border shadow-inner">
//                   🔒 https://mystore.com/swipe-deals
//                 </div>
//               </div>
//               <div className="flex space-x-2">
//                 <div className="w-8 h-8 bg-gray-300 rounded hover:bg-gray-400 transition-colors"></div>
//                 <div className="w-8 h-8 bg-gray-300 rounded hover:bg-gray-400 transition-colors"></div>
//               </div>
//             </div>
//             <div className="w-full h-full pt-12">
//               <SwipeToReveal isDesktop={true} />
//             </div>
//           </div>
//         </div>
//         {/* Desktop Stand */}
//         <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-6">
//           <div className="w-40 h-8 bg-gradient-to-b from-slate-600 to-slate-800 rounded-b-xl shadow-lg"></div>
//           <div className="w-56 h-4 bg-gradient-to-b from-slate-700 to-slate-900 rounded-full mx-auto shadow-lg"></div>
//         </div>
//       </div>
//       {/* Reflection Effect */}
//       <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white to-transparent opacity-10 rounded-2xl pointer-events-none"></div>
//     </div>
//   );
// };

// const ResponsiveSwipeReveal = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 ">
//       {/* Mobile View */}
//       <div className="lg:hidden flex items-center justify-center min-h-screen">
//         <PhoneMockup />
//       </div>
      
//       {/* Both Views for Comparison (visible on xl screens) */}
//       <div className="hidden xl:flex xl:flex-row xl:space-x-16 xl:items-center xl:justify-center xl:min-h-screen xl:py-12">
//         <div className="flex flex-col items-center">
//           <h3 className="text-white text-2xl font-bold mb-6 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-2xl border border-white/20">
//             🖥️ Desktop Experience
//           </h3>
//           <DesktopMockup />
//         </div>
//         <div className="flex flex-col items-center">
//           <h3 className="text-white text-2xl font-bold mb-6 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-2xl border border-white/20">
//             📱 Mobile Experience
//           </h3>
//           <PhoneMockup />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ResponsiveSwipeReveal;


// import React, { useState, useRef, useEffect } from 'react';
// import { ChevronRight, Sparkles, Heart, Star } from 'lucide-react';

// const SwipeRevealAd = () => {
//   const [swipeProgress, setSwipeProgress] = useState(0);
//   const [isRevealed, setIsRevealed] = useState(false);
//   const [isDragging, setIsDragging] = useState(false);
//   const containerRef = useRef(null);
//   const startXRef = useRef(0);
//   const currentXRef = useRef(0);

//   const handleStart = (clientX) => {
//     setIsDragging(true);
//     startXRef.current = clientX;
//     currentXRef.current = clientX;
//   };

//   const handleMove = (clientX) => {
//     if (!isDragging) return;
    
//     const container = containerRef.current;
//     if (!container) return;

//     const containerWidth = container.offsetWidth;
//     const deltaX = clientX - startXRef.current;
//     const progress = Math.max(0, Math.min(100, (deltaX / containerWidth) * 100));
    
//     setSwipeProgress(progress);
//     currentXRef.current = clientX;

//     if (progress > 70) {
//       setIsRevealed(true);
//     }
//   };

//   const handleEnd = () => {
//     setIsDragging(false);
    
//     if (swipeProgress > 70) {
//       setSwipeProgress(100);
//       setIsRevealed(true);
//     } else {
//       setSwipeProgress(0);
//       setIsRevealed(false);
//     }
//   };

//   // Mouse events
//   const handleMouseDown = (e) => {
//     handleStart(e.clientX);
//   };

//   const handleMouseMove = (e) => {
//     handleMove(e.clientX);
//   };

//   const handleMouseUp = () => {
//     handleEnd();
//   };

//   // Touch events
//   const handleTouchStart = (e) => {
//     handleStart(e.touches[0].clientX);
//   };

//   const handleTouchMove = (e) => {
//     e.preventDefault();
//     handleMove(e.touches[0].clientX);
//   };

//   const handleTouchEnd = () => {
//     handleEnd();
//   };

//   useEffect(() => {
//     if (isDragging) {
//       document.addEventListener('mousemove', handleMouseMove);
//       document.addEventListener('mouseup', handleMouseUp);
//       document.addEventListener('touchmove', handleTouchMove, { passive: false });
//       document.addEventListener('touchend', handleTouchEnd);
//     }

//     return () => {
//       document.removeEventListener('mousemove', handleMouseMove);
//       document.removeEventListener('mouseup', handleMouseUp);
//       document.removeEventListener('touchmove', handleTouchMove);
//       document.removeEventListener('touchend', handleTouchEnd);
//     };
//   }, [isDragging]);

//   const resetAd = () => {
//     setSwipeProgress(0);
//     setIsRevealed(false);
//   };

//   return (
//     <div className="h-screen w-full overflow-hidden bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 relative select-none">
//       {/* Background Animation */}
//       <div className="absolute inset-0">
//         <div className="absolute top-20 left-10 w-2 h-2 bg-white rounded-full animate-pulse opacity-60"></div>
//         <div className="absolute top-40 right-20 w-1 h-1 bg-pink-300 rounded-full animate-bounce opacity-80"></div>
//         <div className="absolute bottom-32 left-20 w-3 h-3 bg-blue-300 rounded-full animate-pulse opacity-50"></div>
//         <div className="absolute bottom-20 right-10 w-2 h-2 bg-purple-300 rounded-full animate-bounce opacity-70"></div>
//       </div>

//       {/* Main Container */}
//       <div 
//         ref={containerRef}
//         className="h-full w-full relative flex items-center justify-center"
//         onMouseDown={handleMouseDown}
//         onTouchStart={handleTouchStart}
//       >
//         {/* Initial State - Hidden Product */}
//         <div 
//           className={`absolute inset-0 transition-all duration-500 ${
//             isRevealed ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
//           }`}
//         >
//           <div className="h-full flex flex-col items-center justify-center text-white px-6">
//             <div className="mb-8 relative">
//               <div className="w-32 h-32 md:w-48 md:h-48 bg-gradient-to-r from-pink-500 to-violet-500 rounded-3xl flex items-center justify-center shadow-2xl transform hover:scale-105 transition-transform">
//                 <div className="w-20 h-20 md:w-32 md:h-32 bg-white bg-opacity-20 rounded-2xl flex items-center justify-center backdrop-blur-sm">
//                   <Sparkles className="w-10 h-10 md:w-16 md:h-16 text-white animate-pulse" />
//                 </div>
//               </div>
//               <div className="absolute -top-2 -right-2 w-6 h-6 bg-yellow-400 rounded-full flex items-center justify-center animate-bounce">
//                 <Star className="w-3 h-3 text-yellow-800" />
//               </div>
//             </div>
            
//             <h1 className="text-2xl md:text-4xl font-bold text-center mb-4 bg-gradient-to-r from-pink-300 to-violet-300 bg-clip-text text-transparent">
//               Something Amazing
//             </h1>
//             <p className="text-sm md:text-lg text-center text-gray-300 mb-8 max-w-md">
//               Swipe right to reveal the surprise waiting for you
//             </p>
            
//             {/* Swipe Indicator */}
//             <div className="flex items-center space-x-3 text-gray-400">
//               <div className="flex space-x-1">
//                 <div className="w-2 h-2 bg-gray-400 rounded-full animate-pulse"></div>
//                 <div className="w-2 h-2 bg-gray-400 rounded-full animate-pulse delay-100"></div>
//                 <div className="w-2 h-2 bg-gray-400 rounded-full animate-pulse delay-200"></div>
//               </div>
//               <ChevronRight className="w-5 h-5 animate-bounce" />
//               <span className="text-sm">Swipe to reveal</span>
//             </div>
//           </div>
//         </div>

//         {/* Revealed State - Product Details */}
//         <div 
//           className={`absolute inset-0 transition-all duration-700 ${
//             isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
//           }`}
//         >
//           <div className="h-full flex flex-col items-center justify-center text-white px-6">
//             <div className="mb-6 relative">
//               <div className="w-40 h-40 md:w-56 md:h-56 bg-gradient-to-r from-emerald-400 to-cyan-400 rounded-3xl flex items-center justify-center shadow-2xl animate-pulse">
//                 <div className="w-28 h-28 md:w-40 md:h-40 bg-white bg-opacity-30 rounded-2xl flex items-center justify-center backdrop-blur-sm">
//                   <Heart className="w-14 h-14 md:w-20 md:h-20 text-white animate-bounce" />
//                 </div>
//               </div>
//               <div className="absolute -top-3 -right-3 w-8 h-8 bg-red-500 rounded-full flex items-center justify-center animate-pulse text-xs font-bold">
//                 NEW
//               </div>
//             </div>
            
//             <h2 className="text-3xl md:text-5xl font-bold text-center mb-4 bg-gradient-to-r from-emerald-300 to-cyan-300 bg-clip-text text-transparent animate-fade-in">
//               Premium Product
//             </h2>
//             <p className="text-base md:text-xl text-center text-gray-300 mb-6 max-w-lg">
//               Discover the ultimate experience with our revolutionary new product
//             </p>
            
//             <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-6 mb-8">
//               <div className="text-center">
//                 <div className="text-2xl md:text-3xl font-bold text-emerald-400">$99</div>
//                 <div className="text-sm text-gray-400 line-through">$199</div>
//               </div>
//               <div className="text-center">
//                 <div className="text-lg font-semibold text-cyan-400">50% OFF</div>
//                 <div className="text-xs text-gray-400">Limited Time</div>
//               </div>
//             </div>
            
//             <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-4">
//               <button className="px-8 py-3 bg-gradient-to-r from-emerald-500 to-cyan-500 rounded-full font-semibold text-white shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200">
//                 Buy Now
//               </button>
//               <button 
//                 onClick={resetAd}
//                 className="px-8 py-3 bg-white bg-opacity-20 backdrop-blur-sm rounded-full font-semibold text-white border border-white border-opacity-30 hover:bg-opacity-30 transition-all duration-200"
//               >
//                 Learn More
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Swipe Progress Overlay */}
//         <div 
//           className="absolute inset-0 pointer-events-none"
//           style={{
//             background: `linear-gradient(90deg, transparent ${swipeProgress}%, rgba(0,0,0,0.3) ${swipeProgress}%)`,
//             transition: isDragging ? 'none' : 'background 0.3s ease'
//           }}
//         />

//         {/* Progress Bar */}
//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 w-64 h-2 bg-white bg-opacity-20 rounded-full overflow-hidden">
//           <div 
//             className="h-full bg-gradient-to-r from-pink-400 to-violet-400 transition-all duration-200 rounded-full"
//             style={{ width: `${swipeProgress}%` }}
//           />
//         </div>

//         {/* Mobile Hint */}
//         <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 text-center text-white text-sm opacity-70 md:hidden">
//           <div className="animate-bounce mb-2">👆</div>
//           <div>Swipe right to reveal</div>
//         </div>

//         {/* Desktop Hint */}
//         <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 text-center text-white text-sm opacity-70 hidden md:block">
//           <div className="animate-bounce mb-2">🖱️</div>
//           <div>Click and drag right to reveal</div>
//         </div>
//       </div>

//       {/* Floating Particles */}
//       <div className="absolute inset-0 pointer-events-none overflow-hidden">
//         {[...Array(6)].map((_, i) => (
//           <div
//             key={i}
//             className={`absolute w-1 h-1 bg-white rounded-full opacity-40 animate-float-${i % 3 + 1}`}
//             style={{
//               left: `${Math.random() * 100}%`,
//               top: `${Math.random() * 100}%`,
//               animationDelay: `${i * 0.5}s`
//             }}
//           />
//         ))}
//       </div>

//       <style jsx>{`
//         @keyframes float-1 {
//           0%, 100% { transform: translateY(0px) rotate(0deg); }
//           50% { transform: translateY(-20px) rotate(180deg); }
//         }
//         @keyframes float-2 {
//           0%, 100% { transform: translateY(0px) rotate(0deg); }
//           50% { transform: translateY(-15px) rotate(90deg); }
//         }
//         @keyframes float-3 {
//           0%, 100% { transform: translateY(0px) rotate(0deg); }
//           50% { transform: translateY(-25px) rotate(270deg); }
//         }
//         @keyframes fade-in {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .animate-float-1 { animation: float-1 4s ease-in-out infinite; }
//         .animate-float-2 { animation: float-2 3s ease-in-out infinite; }
//         .animate-float-3 { animation: float-3 5s ease-in-out infinite; }
//         .animate-fade-in { animation: fade-in 0.8s ease-out; }
//       `}</style>
//     </div>
//   );
// };

// export default SwipeRevealAd;

// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { Smartphone, Laptop, Tablet, Headphones, Watch } from 'lucide-react';

// const AdPage2= () => {
//   const [selectedProduct, setSelectedProduct] = useState(0);

//   const products = [
//     { icon: Smartphone, name: 'SmartPhone X', price: '$999', color: 'from-blue-500 to-cyan-500' },
//     { icon: Laptop, name: 'UltraBook Pro', price: '$1,999', color: 'from-purple-500 to-pink-500' },
//     { icon: Tablet, name: 'TabletMax', price: '$799', color: 'from-green-500 to-teal-500' },
//     { icon: Headphones, name: 'AudioPro', price: '$299', color: 'from-orange-500 to-red-500' },
//     { icon: Watch, name: 'SmartWatch', price: '$399', color: 'from-indigo-500 to-purple-500' }
//   ];

//   const SelectedIcon = products[selectedProduct].icon;

//   return (
//     <div className="min-h-screen bg-black text-white overflow-hidden mt-12">
//       {/* Grid Background */}
//       <div className="absolute inset-0 opacity-10">
//         <div className="grid grid-cols-12 grid-rows-12 h-full">
//           {[...Array(144)].map((_, i) => (
//             <motion.div
//               key={i}
//               className="border border-white/20"
//               animate={{ opacity: [0.1, 0.3, 0.1] }}
//               transition={{ duration: 3, delay: i * 0.01, repeat: Infinity }}
//             />
//           ))}
//         </div>
//       </div>

//       <div className="relative z-10 flex h-screen">
//         {/* Left Side - Product List */}
//         <div className="w-1/3 p-8 flex flex-col justify-center">
//           <motion.h1
//             initial={{ x: -100, opacity: 0 }}
//             animate={{ x: 0, opacity: 1 }}
//             transition={{ duration: 0.8 }}
//             className="text-6xl font-bold mb-12 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent"
//           >
//             TECH
//             <br />
//             <span className="text-4xl">REVOLUTION</span>
//           </motion.h1>

//           <div className="space-y-4">
//             {products.map((product, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ x: -50, opacity: 0 }}
//                 animate={{ x: 0, opacity: 1 }}
//                 transition={{ delay: index * 0.1, duration: 0.5 }}
//                 className={`p-4 rounded-xl cursor-pointer transition-all duration-300 ${
//                   selectedProduct === index
//                     ? 'bg-white/20 border-2 border-white/50'
//                     : 'bg-white/5 border border-white/20 hover:bg-white/10'
//                 }`}
//                 onClick={() => setSelectedProduct(index)}
//                 whileHover={{ scale: 1.02 }}
//                 whileTap={{ scale: 0.98 }}
//               >
//                 <div className="flex items-center gap-4">
//                   <div className={`p-3 rounded-lg bg-gradient-to-r ${product.color}`}>
//                     <product.icon className="w-6 h-6 text-white" />
//                   </div>
//                   <div>
//                     <h3 className="font-semibold">{product.name}</h3>
//                     <p className="text-gray-400">{product.price}</p>
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>

//         {/* Right Side - Product Showcase */}
//         <div className="w-2/3 flex items-center justify-center p-8">
//           <AnimatePresence mode="wait">
//             <motion.div
//               key={selectedProduct}
//               initial={{ scale: 0, rotate: -180, opacity: 0 }}
//               animate={{ scale: 1, rotate: 0, opacity: 1 }}
//               exit={{ scale: 0, rotate: 180, opacity: 0 }}
//               transition={{ duration: 0.8, type: 'spring' }}
//               className="relative"
//             >
//               {/* Rotating Ring */}
//               <motion.div
//                 animate={{ rotate: 360 }}
//                 transition={{ duration: 10, repeat: Infinity, ease: 'linear' }}
//                 className="absolute inset-0 w-96 h-96 border-4 border-dashed border-white/30 rounded-full scale-150"
//               />

//               {/* Product Display */}
//               <div
//                 className={`w-80 h-80 rounded-full bg-gradient-to-br ${products[selectedProduct].color} flex items-center justify-center shadow-2xl`}
//               >
//                 <motion.div
//                   animate={{
//                     scale: [1, 1.1, 1],
//                     rotate: [0, 5, -5, 0]
//                   }}
//                   transition={{ duration: 2, repeat: Infinity }}
//                 >
//                   <SelectedIcon className="w-32 h-32 text-white" />
//                 </motion.div>
//               </div>

//               {/* Product Info */}
//               <motion.div
//                 initial={{ y: 50, opacity: 0 }}
//                 animate={{ y: 0, opacity: 1 }}
//                 transition={{ delay: 0.3 }}
//                 className="absolute -bottom-20 left-1/2 transform -translate-x-1/2 text-center"
//               >
//                 <h2 className="text-4xl font-bold mb-2">{products[selectedProduct].name}</h2>
//                 <p className="text-2xl text-gray-400 mb-4">{products[selectedProduct].price}</p>
//                 <motion.button
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   className="bg-white text-black px-8 py-3 rounded-full font-semibold hover:bg-gray-200 transition-colors"
//                 >
//                   Order Now
//                 </motion.button>
//               </motion.div>
//             </motion.div>
//           </AnimatePresence>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdPage2;
